import { GoArrowLeft  } from "react-icons/go";
import { CiGlobe ,CiBank ,CiRead,CiStar   } from "react-icons/ci";
export const Inspire = () => {


  return (
      <div>
          <div className="relative isolate overflow-hidden bg-white  lg:overflow-visible lg:px-0">

              <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8  lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start ">
                  <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8">
                      <div className="lg:pr-4">
                          <div className="lg:max-w-lg">
                              <a href={"/company/integrations"} className="text-sm items-center flex font-semibold text-indigo-600"><GoArrowLeft className={"h-5 w-5 mr-2"}/>Zurück</a>
                              <h1 className="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 ">
                                  Inspire - Schnittstelle
                              </h1>
                              <p className="mt-6 text-sm text-gray-700">
                                  XPläne europaweit sichtbar machen – jetzt mit der neuen INSPIRE-Schnittstelle
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className="-mt-12 -ml-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
                      <img
                          alt=""
                          src={`${process.env.PUBLIC_URL}/integrations/inspire/mainImage.jpg`}
                          className="  rounded-xl bg-gray-900 ring-1 ring-gray-400/10 "
                      />
                  </div>
                  <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 ">
                      <div className="lg:pr-4">
                          <div className="max-w-xl text-sm text-gray-700 lg:max-w-lg">
                              <p>
                                  Mit der neuen INSPIRE-Schnittstelle können XPlan-konforme Bauleitpläne jetzt direkt im Open Data Portal der Europäischen Union veröffentlicht werden – standardisiert, automatisiert und vollständig INSPIRE-konform.<br/><br/>
                                  Das bedeutet: Ihre Planungsdaten werden nicht nur national, sondern auch europaweit interoperabel und auffindbar – ein wichtiger Schritt für transparente, offene Verwaltung und echte Datenverfügbarkeit im Sinne der EU-Richtlinie.
                              </p>
                              <ul role="list" className="mt-8 space-y-8 text-gray-600">
                                  <li className="flex items-center gap-x-3">
                                      <CiGlobe  aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Veröffentlichung</strong> Ihrer XPläne im offiziellen INSPIRE Geoportal der EU
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiBank   aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Erfüllung gesetzlicher Vorgaben</strong> zur EU-Datenbereitstellung
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiStar  aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Förderung </strong> von Open Data, Nachnutzung und europäischer Zusammenarbeit
                                      </span>
                                  </li>
                                  <li className="flex items-center  gap-x-3">
                                      <CiRead   aria-hidden="true" className="mt-1 size-8 flex-none text-indigo-600" />
                                      <span>
                                        <strong className="font-semibold text-gray-900">Stärkung</strong> der Sichtbarkeit und Relevanz kommunaler Planungsdaten
                                      </span>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <button className={"bg-gray-900 text-white p-3 rounded-lg mb-12"}> Schnittstelle aktivieren</button>


              </div>
          </div>
      </div>
  )
}
